export const DATA_LOADING = 'Loading ...';
export const DATA_REGISTER = 'Memproses registrasi ...';
export const DATA_SAVING = 'Menyimpan perubahan ...';
